import type { FaireProductEntity } from "../../entity_types/product";

export const p_hn3c7uzdff: FaireProductEntity = {
  token: "p_hn3c7uzdff",
  type: "product",
  name: "Kiso Forest Hand Soap",
  brandToken: "b_xjywu3etzs",
  brandName: "Element Brooklyn",
  imageUrl:
    "https://cdn.faire.com/fastly/8f65ceddf55d3885396fbfd15ff94ab87e6676e7fbcf4bb7de94e3d4b6a4aeea.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/538c238b24b7c4e2aa53989dc043b2cb5f77460e67938132d95128b834a1c5ce.jpeg",
    "https://cdn.faire.com/fastly/47538a9f204dda595bff6e734309cf6dd63d02ee3b127e69ddf2b2288545040f.png",
    "https://cdn.faire.com/fastly/c02aff065c7d4dc62278f230b9b7641f1fe125e3a68dba5bb185ffa76204e5a1.jpeg",
    "https://cdn.faire.com/fastly/532915525d5e32e415f4abeff312eabdd3894dc03754bc23d55a0f83a06c327b.jpeg",
  ],
  priceDollars: 12.1,
  description:
    "Japan's Kiso Forest is home to the Hinoki cypress, whose wood has been used in the building of Sento bathhouses as well as sacred shrines and temples for centuries.\n\nInspired by the Hinoki’s calming and uplifting properties, using the products in our Kiso Forest range is like strolling through a glistening evergreen forest.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:31.350Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
